import {URL_BACKEND} from "../configs/url-config";

const tokens = {
    dbUrl: `${URL_BACKEND}/login`,
    limbobot: `${URL_BACKEND}/limbobot?`,
}

export default tokens